const s = {
  name: "ShopperRisk",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M15,13v8h7.7l-8.2,14H13v-8H5.3l8.2-14H15z M13,17.7L8.7,25H15v5.3l4.3-7.3H13V17.7z"/>
		<path class="st0" d="M7,7v1H0v32h28V8h-7V7c0-3.9-3.1-7-7-7S7,3.1,7,7z M14,2c2.8,0,5,2.2,5,5v1H9V7C9,4.2,11.2,2,14,2z M7,15h2
			v-5h10v5h2v-5h5v28H2V10h5V15z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as ShopperRisk
};
